import { render, staticRenderFns } from "./imagenes.vue?vue&type=template&id=538bbc69&"
import script from "./imagenes.vue?vue&type=script&lang=js&"
export * from "./imagenes.vue?vue&type=script&lang=js&"
import style0 from "./imagenes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports